import { AlertCircle } from 'lucide-react';
import { useKyc } from '../../context/KycContext';
import { useNavigate } from 'react-router';

export default function KycBadge() {
    const { hasAlerts, alertsCount } = useKyc();
    const navigate = useNavigate();

    if (!hasAlerts) {
        return null;
    }

    return (
        <button
            onClick={() => navigate('/finance?tab=identity')}
            className="flex items-center gap-2 px-3 py-1.5 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg hover:bg-yellow-100 dark:hover:bg-yellow-900/30 transition-colors"
        >
            <AlertCircle className="w-4 h-4 text-yellow-600 dark:text-yellow-500" />
            <span className="text-xs font-medium text-yellow-700 dark:text-yellow-400">
                {alertsCount} documento{alertsCount > 1 ? 's' : ''} pendente{alertsCount > 1 ? 's' : ''}
            </span>
        </button>
    );
}
